
























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { postObject } from "@/store/actions";
import store from "@/store/store";
import moment from "moment";
import axios from "axios";
import { Question, Answer } from "../common/interfaces";
import { ActionNames } from "@/store/actions";
import { MutationNames } from "@/store/mutations";

@Component({})
export default class ChecklistQuestion extends Vue {
  @Prop()
  public question: Question;

  private loadingAnswer: boolean = true;
  private answerDB: string = "";

  get getAnswerFromStore() {
    if (store.state.Job.ChecklistQAs) {
      return store.state.Job.ChecklistQAs[this.question.QuestionId];
    }
  }

  get allAnswers() {
    return store.state.Answers;
  }

  public async answerChanged(newValue: object) {
    try {
      await store.dispatch(ActionNames.SaveChecklistQARow, {
        questionKey: this.question.QuestionId,
        answerKey: newValue
      });
    } catch (err) {
      this.$notify.error({
        title: "Error",
        message: err.message,
        offset: 48
      });
    }
  }
}
